export const truncateText = (text = "", maxLength = 60, options = {}) => {
  const { ellipsis = "..." } = options;
  const normalized =
    typeof text === "string" ? text : text == null ? "" : String(text);
  if (!normalized) {
    return { text: "", isTruncated: false };
  }

  const shouldTruncate = normalized.length > maxLength;
  if (!shouldTruncate) {
    return { text: normalized, isTruncated: false };
  }

  const clipped = normalized.slice(0, maxLength).trimEnd();
  return { text: `${clipped}${ellipsis}`, isTruncated: true };
};

// Sanitize string for safe filename: remove special characters, replace spaces.
export const sanitizeForFilename = (value) => {
  const cleaned = String(value ?? "")
    .trim()
    .replace(/[\\/:*?"<>|]/g, "")
    .replace(/\s+/g, "_");
  return cleaned || "Unknown";
};
